module.exports = __webpack_public_path__ + "static/media/GraduationPic.b4df378e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/GraduationPic.jpg
// module id = 43
// module chunks = 0